import classNames from 'classnames';

export const getFooterDSLabel = ({
  configs,
  prefix = '',
  suffix = '',
  customClasses = '',
  customStyles = {},
}) => {
  const showDsLabel = !!(configs?.ds_branding_flag ?? 1);

  if (showDsLabel) {
    return (
      <>
        {prefix ? `${prefix} powered` : 'Powered'} by &nbsp;
        <a
          href="https://download.digitalshowroom.app/download-cfe"
          target="_blank"
          className={classNames(
            'underline copyright-text-grey-color tw-cursor-pointer',
            customClasses
          )}
          rel="website app link noreferrer"
          style={customStyles}
        >
          Digital Showroom {suffix}
        </a>
      </>
    );
  }
  return null;
};
